module.exports = __webpack_public_path__ + "media/images/lb/293-0c239d5bbfb2e333faf7d6f04c981e16.svg";